import { Button, CircularProgress } from "@mui/material";
import React, { JSX } from "react";
import styled from "styled-components";
import { Spacing } from "../../config";

import FontStyles from "../styles/fontStyles";

import { useFormFull } from "form-full";
interface StyledCircularProgressProps {
  $show: boolean;
}

interface StyledButtonProps {
  $defaultColor?: boolean;
}
const StyledButton = styled(Button)<StyledButtonProps>(
  ({ theme, $defaultColor, fullWidth, disabled }) => {
    return {
      "&&.MuiButton-root": {
        display: "flex",
        alignItems: "center",
        borderRadius: Spacing(3.37500),
        justifyContent: "center",
        padding: Spacing(1.5, 3),
        marginTop: Spacing(0.75),
        width: fullWidth ? "100%" : "fit-content",
        overflow: "hidden",
        ...FontStyles.medium16,

        textTransform: "capitalize",
        color: $defaultColor ? "black" : theme.palette.text.secondary,
        opacity: disabled ? 0.6 : 1,
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px",
          paddingBlock: "12px",
          paddingInline: "25px",
        },
      },
    };
  }
);
const StyledCircularProgress = styled(CircularProgress)<StyledCircularProgressProps>(({ theme, $show }) => {
  const { palette: colors } = theme;
  return {
    position: "absolute",
    color: colors.text.primary,
    transition: ".5s",
    opacity: $show ? 1 : 0,
  };
});

const ChildrenContainer = styled.div<StyledCircularProgressProps>(({ $show }) => {
  return {
    transition: ".5s",
    opacity: $show ? 1 : 0.5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
});
interface Props {
  fullWidth?: boolean;
  label?: string;
  children?: React.ReactNode;

  disabled?: boolean;
  loading?: boolean;
  name?: string;
  feedback?: boolean;
  action?: "submit" | "clear" | "clearDefault";

  onClick?: (event: any) => void;

  [key: string]: any;
}
function ButtonTextComponent({
  fullWidth = true,
  label,
  children,

  disabled,
  loading,
  name,
  feedback,
  action,

  onClick: onClickProps,
  ...props
}: Props): JSX.Element {
  const { onClick, formLoading, formDisabled } = useFormFull.button({
    feedback,
    action,
    onClick: onClickProps,
  });
  const isLoading = !!(loading || formLoading);
  return (
    <StyledButton
      variant="text"
      loading={loading || formLoading}
      disabled={disabled || formDisabled}
      fullWidth={fullWidth}
      onClick={onClick}
      {...props}
    >
      <StyledCircularProgress size={Spacing(3)} $show={isLoading} />

      <ChildrenContainer $show={!isLoading}>{children}</ChildrenContainer>
    </StyledButton>
  );
}

export default ButtonTextComponent;
